import { ProjectDataInterface } from "./interfaces";

export const getProjectsData = (): ProjectDataInterface =>
  JSON.parse(localStorage.getItem("projects")) || {};

export const saveProjectsData = (data: ProjectDataInterface | {}): void =>
  localStorage.setItem("projects", JSON.stringify(data));
